import script from "./profileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./profileModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__